import React from 'react';
import {AppRouter} from './routes/AppRouter'
import { useIframeHeight } from './hooks/useIframeHeight';

const  App = () => {
  // Notifica al portal (Joomla / SP Page Builder) la altura real del
  // contenido para que el iframe se ajuste dinamicamente.
  useIframeHeight();

  return (
    <AppRouter />
  );
}

export default App;
